import classes from "./SideNavigation.module.css";
import { Link } from "react-scroll";
import profile from "../assets/img/profile.png";

const SideNavigation = () => {
  return (
    <div className={classes["side-navigation"]}>
      <div className={classes["upper-body"]}>
        <img src={profile} className={classes["profile"]} />
        <h1>Abhishek Chamoli</h1>
        <h3>Full-Stack Web Application Developer</h3>
        <div className={classes["wrapper"]}>
          <div className={classes["pulse"]}></div>
        </div>
      </div>
      <div className={classes["side-navigation-links"]}>
        <ul>
          <li>
            <Link
              className={classes["nav-link"]}
              to="home"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
            >
              <i class="fa fa-home fa-xl"></i> <p>Home</p>
            </Link>
          </li>
          <li>
            <Link
              className={classes["nav-link"]}
              to="about"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
            >
              <i class="fa fa-user  fa-xl "></i> <p>About</p>
            </Link>
          </li>
          <li>
            <Link
              className={classes["nav-link"]}
              to="skill"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
            >
              <i class="fa fa-hammer   fa-xl "></i> <p>Skill</p>
            </Link>
          </li>
          <li>
            <Link
              className={classes["nav-link"]}
              to="services"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
            >
              <i class="fa fa-star   fa-xl "></i> <p>Services</p>
            </Link>
          </li>
          <li>
            <Link
              className={classes["nav-link"]}
              to="contacts"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
            >
              <i class="fa fa-phone   fa-xl "></i> <p>Contact us</p>
            </Link>
          </li>
        </ul>
      </div>
      <div className={classes.resume}>
        <a href="https://drive.google.com/uc?export=download&id=1C-CoD5FAvCwq02-klWs5pYKEHgvQVLq0">
          <div className={classes["resume-link"]}>
            <i class="fas fa-download   fa-xl "></i>
            <a herf="/home">Resume</a>
          </div>
        </a>
      </div>
    </div>
  );
};

export default SideNavigation;
